<template>
  <KkLoading v-if="servicePatternLoading" />
  <div v-else-if="!isSetPatterns && showTutorial">
    <KkTutorial
      :description1="$t('pages.companies.services.tutorial.noServiceDescription1')"
      :description2="$t('pages.companies.services.tutorial.noServiceDescription2')"
      :img-path="tutorialImgPath"
      :tutorial-description="$t('pages.companies.services.tutorial.description')"
    >
      <template #buttonArea>
        <KkButton
          color="primary"
          :text="$t('pages.companies.services.tutorial.registerService')"
          @click="showTutorial = false"
        />
      </template>
    </KkTutorial>
  </div>
  <template v-else>
    <div>
      <div class="p-box">
        <div class="p-box__body">
          <KkInfo>{{ $t('pages.companies.services.info') }}</KkInfo>
          <div v-for="(servicePattern, index) in servicePatterns" :key="index" class="section">
            <KkBox :title="servicePattern.categoryName" border>
              <template #content>
                <KkPatternList
                  v-if="servicePattern.servicePatterns.length"
                  :patterns="servicePattern.servicePatterns"
                  :category-id="servicePattern.gmbCategoryId"
                />
                <p v-else>{{ $t('pages.companies.services.notFound') }}</p>
                <div class="add">
                  <KkAddLabel :label="$t('pages.companies.services.add')" @click="linkTo(servicePattern.gmbCategoryId)" />
                </div>
              </template>
            </KkBox>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { KkButton, KkBox, KkLoading } from '../../components/base'
import { KkAddLabel, KkInfo } from '../../components/ui'
import { KkTutorial } from '../../components/projects'
import { KkPatternList } from '../../components/domains/service'
import tutorialImgPath from '../../../../images/services/tutorial.png'

export default {
  name: 'CompaniesServices',
  components: {
    KkButton,
    KkBox,
    KkLoading,
    KkAddLabel,
    KkInfo,
    KkTutorial,
    KkPatternList,
  },
  data() {
    return {
      showTutorial: true
    }
  },
  computed: {
    ...mapState({
      servicePatterns: state => state.companiesServicePatterns.servicePatterns,
      servicePatternLoading: state => state.companiesServicePatterns.servicePatternLoading,
      tutorialImgPath: () => tutorialImgPath
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    isSetPatterns() {
      let patternCount = 0
      if (this.servicePatterns.length) {
        for (let servicePattern of this.servicePatterns) {
          patternCount += servicePattern.servicePatterns.length
        }
      }
      return patternCount != 0
    }
  },
  created() {
    this.readServicePatterns()
  },
  methods: {
    ...mapActions({
      readServicePatterns: 'companiesServicePatterns/readServicePatterns',
    }),
    linkTo(id) {
      this.$router.push({
        name: 'CompaniesServicesNew',
        params: { company_uuid: this.companyUuid, category_id: id }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.section {
  margin-top: 16px;
  + .section {
    margin-top: 48px;
  }
}
.add {
  margin-top: 16px;
}
</style>
